<div
  cdkDropList
  [cdkDropListData]="bookmarks"
  [cdkDropListConnectedTo]="connectedTo"
  [id]="listId"
  (cdkDropListDropped)="drop($event)"
  class="grid grid-nogutter max-h-10rem overflow-auto">
  <div
    class="col-12"
    *ngFor="
      let item of bookmarks;
      let first = first;
      let last = last;
      trackBy: trackByItem
    "
    [cdkDragData]="item"
    cdkDrag
    (contextmenu)="onContextMenuOpen($event, item)"
    #cm>
    <div
      [ngClass]="{ 'border-round-bottom-2xl': last }"
      pTooltip="Rechtsklick für weitere Optionen"
      showDelay="800"
      class="align-items-center surface-100 flex flex-column xl:flex-row p-3 gap-3 border-top-1 surface-border relative">
      @if (globalsStore.activeCommune()?.defaultBookmark === item._id) {
        <i class="fas fa-star"></i>
      } @else if (
        globalsStore.activeCommune()?.defaultBookmarkExternal === item._id
      ) {
        <i class="fa-regular fa-star"></i>
      } @else if (item.private) {
        <i class="fas fa-eye-slash" pTooltip="private Ansicht"></i>
      } @else {
        <i
          [class]="
            item.published ? 'fas fa-earth-europe' : 'fas fa-house-user'
          "></i>
      }
      <span>{{ item.title }}</span>
      <span class="ml-auto flex gap-2">
        @if (item.guestLink?.enabled) {
          <i class="fas fa-link"></i>
        }
        <i
          class="fas fa-circle-user"
          *ngIf="activeUserStore.user()?._id === item.user"></i>
      </span>
    </div>
    <p-contextMenu
      [target]="cm"
      [model]="contextMenuBookmarks"
      appendTo="body"></p-contextMenu>
  </div>

  <div class="col-12" *ngIf="!bookmarks.length">
    <div
      class="align-items-center surface-100 border-round-bottom-2xl flex flex-column xl:flex-row p-3 gap-3 border-top-1 surface-border">
      <span class="font-italic text-color-secondary"
        >Keine Ansichten gefunden</span
      >
    </div>
  </div>
</div>
